import PortfolioConfigData from "config/portfolio-config.json";
import React from "react";
import EfficientFrontierChart from "./components/EfficientFrontierChart";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";

type SectionChildrenProps = {
  ef_data: any;
  reportData: any;
  isOptimized?: boolean;
};
const EfficientFrontierContainer: React.FC<SectionChildrenProps> = ({
  ef_data,
  reportData,
  isOptimized,
}) => {
  const selectedPlan = ef_data[reportData.data?.financial_plan - 1];
  const portfolio = {
    risk: reportData.data?.var * 100,
    return: reportData.data?.return * 100,
  };

  return (
    <div className={commonStyles.sectionContainer}>
      <h3 className={commonStyles.titleChart}>
        {
          PortfolioConfigData.analisi_rischio_rendimento_atteso.data
            .efficient_frontier_data.label
        }
      </h3>
      <div className={commonStyles.marginTop16}></div>
      <EfficientFrontierChart
        data={ef_data}
        selectedPlan={selectedPlan}
        portfolio={portfolio}
        isOptimized={isOptimized}
      />
    </div>
  );
};
export default EfficientFrontierContainer;
